import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { appendTeamMemberLawyerId } from "../../../../styles/styles";
import { backend_api } from "../../../../static/server";

export const getLoginUserData = createAsyncThunk(
  "getLoginUserData",
  async ({ url, token }) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const getFirmData = createAsyncThunk(
  "getFirmData",
  async ({ url=`${backend_api}firm/create-law-firm/`, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const getTargeRangeData = createAsyncThunk(
  "getTargeRangeData",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

const DashboardSlice = createSlice({
  name: "DashboardSlice",
  initialState: {
    firmData: null,
    firmPagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    targetRangeData: null,
    targetRangePagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
    LoginUserData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // getFirmData
      .addCase(getFirmData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFirmData.fulfilled, (state, action) => {
        state.loading = false;
        state.firmData = action?.payload?.results || action?.payload;
        state.firmPagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getFirmData.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message || "Failed to get any firm";
      })

      // getLoginUserData
      .addCase(getLoginUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLoginUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.LoginUserData = action?.payload;
      })
      .addCase(getLoginUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message || "Failed to get any user data";
      })

      .addCase(getTargeRangeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTargeRangeData.fulfilled, (state, action) => {
        state.loading = false;
        state.targetRangeData = action?.payload?.results || action?.payload;
        state.targetRangePagination = {
          ...action?.payload?.pagination,
          count: action?.payload?.count,
          next: action?.payload?.next,
          previous: action?.payload?.previous,
        };
      })
      .addCase(getTargeRangeData.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action?.error?.message || "Failed to get any target range data";
      });
  },
});

export const DashboardReducer = DashboardSlice.reducer;
